// Generated by genversion.
export const version = '5.1227.0';
